import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "DirectRateVotesBrowserView"
}
const _hoisted_2 = { class: "nav nav-tabs" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "tab-content" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table table-striped" }
const _hoisted_9 = { style: {"text-align":"center"} }
const _hoisted_10 = { style: {"text-align":"left"} }
const _hoisted_11 = ["colspan"]
const _hoisted_12 = { style: {"text-align":"left"} }
const _hoisted_13 = { class: "table-responsive" }
const _hoisted_14 = { class: "table" }
const _hoisted_15 = {
  style: {"text-align":"center"},
  class: "bottom noborder"
}
const _hoisted_16 = { style: {"height":"400px","border":"none","padding-top":"20px"} }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { style: {"text-align":"center"} }
const _hoisted_19 = { style: {"width":"5%"} }
const _hoisted_20 = { class: "blockquote" }
const _hoisted_21 = { class: "mb-0" }
const _hoisted_22 = { class: "blockquote-footer" }
const _hoisted_23 = {
  key: 1,
  class: "DirectValueVotesBrowserView"
}
const _hoisted_24 = { class: "nav nav-tabs" }
const _hoisted_25 = { class: "nav-item" }
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = { class: "tab-content" }
const _hoisted_28 = { class: "table-responsive" }
const _hoisted_29 = { class: "table table-striped" }
const _hoisted_30 = { style: {"text-align":"center"} }
const _hoisted_31 = { style: {"text-align":"center"} }
const _hoisted_32 = { style: {"text-align":"left"} }
const _hoisted_33 = { class: "blockquote" }
const _hoisted_34 = { class: "mb-0" }
const _hoisted_35 = { class: "blockquote-footer" }

import { ref, computed } from 'vue'
    import { isNullOrWhitespace } from '@common/Common'

    import type { PanelistVoteReadModel } from '@Evaluation/Estimations/Domain/readmodels'

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VotesBrowser',
  props: {
    AlternativeName: {},
    Entries: {},
    HasScale: { type: Boolean },
    ScaleLevels: {}
  },
  setup(__props: any) {

    const props = __props

    // ---------------- local state ----------------

    const activeTab = ref<'votes' | 'summary' | 'notes'>('votes')

    // ---------------- derived ----------------

    const QuestionScale = computed<number[]>(() =>
        props.ScaleLevels.map(a => a.Value)
    )

    const VotesEntries = computed<PanelistVoteReadModel[]>(() =>
        props.Entries
    )

    const Comments = computed<PanelistVoteReadModel[]>(() =>
        VotesEntries.value.filter(a => !isNullOrWhitespace(a.Comment))
    )

    // ---------------- tab helpers ----------------

    const SummaryTabActive = computed(() => activeTab.value === 'summary')
    const VotesTabActive = computed(() => activeTab.value === 'votes')
    const CommentsTabActive = computed(() => activeTab.value === 'notes')

    function ShowSummaryTabCommand()
    {
        activeTab.value = 'summary'
    }

    function ShowVotesTabCommand()
    {
        activeTab.value = 'votes'
    }

    function ShowCommentsTabCommand()
    {
        activeTab.value = 'notes'
    }

    // ---------------- calculations ----------------

    const Average = computed<number | null>(() =>
    {
        const votes = VotesEntries.value.filter(a => a.Value != null)

        if (votes.length === 0)
            return null

        let sum = 0
        for (const v of votes)
            sum += v.Value!

        return sum / votes.length
    })

    const AverageCells = computed<TdViewModel[]>(() =>
    {
        const cells = QuestionScale.value.map(
            v => new TdViewModel(v, false, false)
        )

        if (Average.value != null)
        {
            const exact = QuestionScale.value.find(
                a => Math.round(100 * a) === Math.round(100 * Average.value!)
            )

            if (exact != null)
            {
                const cell = cells.find(c => c.Value === exact)!
                cell.Highlighted = true
            }
            else
            {
                const before = QuestionScale.value.filter(a => a < Average.value!).length

                const cell = cells[before - 1]
                cell.Highlighted = true
                cell.Value = Average.value!
                cell.Colspan = 2

                // Vue 3 migration rule: array.remove → splice
                cells.splice(before, 1)
            }
        }

        return cells
    })

    const HistogramValues = computed(() =>
    {
        const result: { Value: number; Count: number; PercentOfMax: number }[] = []

        const values = VotesEntries.value
            .filter(a => a.Value != null)
            .map(a => a.Value!)

        let maxCount = 0

        for (const value of QuestionScale.value)
        {
            const count = values.filter(v => v === value).length
            maxCount = Math.max(maxCount, count)
        }

        for (const value of QuestionScale.value)
        {
            const count = values.filter(v => v === value).length
            const percentOfMax = maxCount === 0 ? 0 : Math.round(count / maxCount * 100)

            result.push({
                Value: value,
                Count: count,
                PercentOfMax: percentOfMax
            })
        }

        return result
    })

    // ---------------- runtime VM ----------------

    class TdViewModel
    {
        Colspan: number
        Highlighted: boolean
        Value: number

        constructor(value: number, highlighted: boolean, colspan: boolean)
        {
            this.Colspan = colspan ? 2 : 1
            this.Highlighted = highlighted
            this.Value = value
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.HasScale)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("ul", _hoisted_2, [
            _createElementVNode("li", _hoisted_3, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { 'active': VotesTabActive.value }]),
                onClick: ShowVotesTabCommand
              }, "Votes", 2 /* CLASS */)
            ]),
            _createElementVNode("li", _hoisted_4, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { 'active': SummaryTabActive.value }]),
                onClick: ShowSummaryTabCommand
              }, "Chart", 2 /* CLASS */)
            ]),
            _createElementVNode("li", _hoisted_5, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { 'active': CommentsTabActive.value }]),
                onClick: ShowCommentsTabCommand
              }, "Comments", 2 /* CLASS */)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (VotesTabActive.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([{ 'active': VotesTabActive.value }, "tab-pane pt-2"])
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", _hoisted_9, [
                          _createElementVNode("td", _hoisted_10, [
                            _createElementVNode("strong", null, " Average (" + _toDisplayString(Average.value != null ? Average.value.toFixedIfNeeded(2) : 'N/A') + ") ", 1 /* TEXT */)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(AverageCells.value, (c) => {
                            return (_openBlock(), _createElementBlock("td", {
                              class: _normalizeClass({ 'bg-color-gray': c.Highlighted, 'td-1': c.Colspan === 1, 'td-2': c.Colspan > 1 }),
                              colspan: c.Colspan
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass({ 'fg-color-white': c.Highlighted })
                              }, _toDisplayString(c.Value.toFixedIfNeeded(2)), 3 /* TEXT, CLASS */)
                            ], 10 /* CLASS, PROPS */, _hoisted_11))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.Entries, (e) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: e.ProjectUserId,
                            style: {"text-align":"center"}
                          }, [
                            _createElementVNode("td", _hoisted_12, _toDisplayString(e.ProjectUserName ?? '???'), 1 /* TEXT */),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(QuestionScale.value, (lvl) => {
                              return (_openBlock(), _createElementBlock("td", {
                                class: _normalizeClass({ 'bg-color-green': lvl === e.Value })
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass({ 'fg-color-white': lvl === e.Value })
                                }, _toDisplayString(lvl), 3 /* TEXT, CLASS */)
                              ], 2 /* CLASS */))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ])
                  ])
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            (SummaryTabActive.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass([{ 'active': SummaryTabActive.value }, "tab-pane pt-2"])
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("table", _hoisted_14, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(HistogramValues.value, (hv) => {
                            return (_openBlock(), _createElementBlock("td", _hoisted_16, [
                              (hv.Count)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(hv.Count), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("div", {
                                class: "bg-color-green2",
                                style: _normalizeStyle({height: hv.PercentOfMax + '%'})
                              }, null, 4 /* STYLE */)
                            ]))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        _createElementVNode("tr", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(QuestionScale.value, (v) => {
                            return (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(v.toFixedIfNeeded(2)), 1 /* TEXT */))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                      ])
                    ])
                  ])
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            (CommentsTabActive.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass([{ 'active': CommentsTabActive.value }, "tab-pane pt-2"])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Comments.value, (c) => {
                    return (_openBlock(), _createElementBlock("blockquote", _hoisted_20, [
                      _createElementVNode("p", _hoisted_21, _toDisplayString(c.Comment), 1 /* TEXT */),
                      _createElementVNode("footer", _hoisted_22, _toDisplayString(c.ProjectUserName ?? '???'), 1 /* TEXT */)
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (!__props.HasScale)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("ul", _hoisted_24, [
            _createElementVNode("li", _hoisted_25, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { 'active': VotesTabActive.value }]),
                onClick: ShowVotesTabCommand
              }, "Votes", 2 /* CLASS */)
            ]),
            _createElementVNode("li", _hoisted_26, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { 'active': CommentsTabActive.value }]),
                onClick: ShowCommentsTabCommand
              }, "Comments", 2 /* CLASS */)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            (VotesTabActive.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass([{ 'active': VotesTabActive.value }, "tab-pane pt-2"])
                }, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("table", _hoisted_29, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", _hoisted_30, [
                          _cache[0] || (_cache[0] = _createElementVNode("td", { style: {"text-align":"left"} }, [
                            _createElementVNode("strong", null, [
                              _createElementVNode("span", null, "Average")
                            ])
                          ], -1 /* CACHED */)),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", null, _toDisplayString(Average.value != null ? Average.value.toFixedIfNeeded(2) : 'N/A'), 1 /* TEXT */)
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(VotesEntries.value, (e) => {
                          return (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                            _createElementVNode("td", _hoisted_32, _toDisplayString(e.ProjectUserName ?? '???'), 1 /* TEXT */),
                            _createElementVNode("td", null, _toDisplayString(e.Value), 1 /* TEXT */)
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ])
                    ])
                  ])
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true),
            (CommentsTabActive.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass([{ 'active': CommentsTabActive.value }, "tab-pane pt-2"])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Comments.value, (c) => {
                    return (_openBlock(), _createElementBlock("blockquote", _hoisted_33, [
                      _createElementVNode("p", _hoisted_34, _toDisplayString(c.Comment), 1 /* TEXT */),
                      _createElementVNode("footer", _hoisted_35, _toDisplayString(c.ProjectUserName ?? '???'), 1 /* TEXT */)
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})